/* eslint-disable */
import { useState, useEffect } from "react";

//import gateway and url helper
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";
import { assetImages } from "constants";

const AppointmentDetailsPopup = ({
  selectedAppointmentId = null,
  setSelectedAppointmentId = () => {},
}) => {
  const token = localStorage.getItem("token");
  const [appointmentDetails, setAppointmentDetails] = useState({});
  const [loading, setLoading] = useState(false);

  //function for get appointment details
  const getAppointmentDetails = async () => {
    try {
      setLoading(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_DETAILS_AGENDA +
        `/${selectedAppointmentId}?token=${token}`;

      console.log("requestUrl in get appointment details", requestUrl);

      const response = await getData(requestUrl);

      if (response.status) {
        setAppointmentDetails(response.data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setLoading(false);
    }
  };

  const closePopupHandler = () => {
    setSelectedAppointmentId(null);
  };

  useEffect(() => {
    if (selectedAppointmentId) {
      getAppointmentDetails();
    }
  }, [selectedAppointmentId]);

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0 shadow-lg"
      tabIndex="-1"
      id="appointmentDetailsPopup"
      aria-labelledby="appointmentDetailsPopup"
    >
      {/* Header design similar to SaveEcosystemPopup */}
      <div className="offcanvas-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              event
            </span>{" "}
            {/* Using 'event' icon as a placeholder for appointments */}
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="offcanvasLabelDetailsLabel"
            >
              Appointment Details
            </h3>
            <p className="text-white fs-sm mb-0">
              View appointment information
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={closePopupHandler}
        ></button>
      </div>
      <div className="offcanvas-body p-4">
        {loading ? (
          <div className="text-center text-muted py-5">
            <span className="spinner-border text-primary mb-3"></span>
            <div>Loading appointment details...</div>
          </div>
        ) : appointmentDetails && appointmentDetails._id ? (
          <div className="container-fluid">
            {/* Clinic Info */}
            <div className="card mb-4 border-0 shadow-sm">
              <div className="card-body d-flex align-items-start">
                <img
                  src={
                    appointmentDetails.companyid?.logo?.path
                      ? url.SERVER_URL + appointmentDetails.companyid.logo.path
                      : assetImages.defaultUser
                  }
                  alt="Clinic Logo"
                  className="rounded-circle me-3"
                  style={{ width: 64, height: 64, objectFit: "cover" }}
                />
                <div>
                  <h5 className="mb-1 fw-bold">
                    {appointmentDetails.companyid?.name || "Clinic"}
                  </h5>
                  <div className="mb-1">
                    <span className="fw-bold">Email:</span>{" "}
                    <span className="text-muted">
                      {appointmentDetails.companyid?.email}
                    </span>
                  </div>
                  <div className="mb-1">
                    <span className="fw-bold">Phone:</span>{" "}
                    <span className="text-muted">
                      {appointmentDetails.companyid?.phone}
                    </span>
                  </div>
                  <div className="mb-1">
                    <span className="fw-bold">Location:</span>{" "}
                    <span className="text-muted">
                      {appointmentDetails.companyid?.location}
                    </span>
                  </div>

                  <div>
                    <span className="fw-bold">Country:</span>{" "}
                    <span className="text-muted">
                      {appointmentDetails.companyid?.country}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            {/* Patient & Doctor Info */}
            <div className="row mb-4">
              {/* Patient */}
              <div className="col-md-6 mb-3 mb-md-0">
                <div className="card border-0 shadow-sm">
                  <div className="card-body d-flex align-items-start">
                    <img
                      src={
                        appointmentDetails.userid?.photoimage
                          ? url.SERVER_URL +
                            appointmentDetails.userid.photoimage.path
                          : assetImages.defaultUser
                      }
                      alt="Patient"
                      className="rounded-circle me-3"
                      style={{ width: 48, height: 48, objectFit: "cover" }}
                    />
                    <div>
                      <h6 className="fw-bold mb-1">Patient</h6>
                      <div>
                        {appointmentDetails.userid?.name}{" "}
                        {appointmentDetails.userid?.surname}
                      </div>
                      <small className="text-muted">
                        {appointmentDetails.userid?.email}
                      </small>
                    </div>
                  </div>
                </div>
              </div>
              {/* Doctor */}
              <div className="col-md-6">
                <div className="card border-0 shadow-sm">
                  <div className="card-body d-flex align-items-start">
                    <img
                      src={
                        appointmentDetails.meetinguserid?.photoimage?.path
                          ? url.SERVER_URL +
                            appointmentDetails.meetinguserid.photoimage.path
                          : assetImages.defaultUser
                      }
                      alt="Doctor"
                      className="rounded-circle me-3"
                      style={{ width: 48, height: 48, objectFit: "cover" }}
                    />
                    <div>
                      <h6 className="fw-bold mb-1">Doctor</h6>
                      <div>
                        {appointmentDetails.meetinguserid?.name}{" "}
                        {appointmentDetails.meetinguserid?.surname}
                      </div>
                      <small className="text-muted">
                        {appointmentDetails.meetinguserid?.email}
                      </small>
                      <div className="text-muted fs-sm">
                        {appointmentDetails.meetinguserid?.city},{" "}
                        {appointmentDetails.meetinguserid?.country}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Appointment Info */}
            <div className="card mb-4 border-0 shadow-sm">
              <div className="card-body">
                <div className="row mb-2">
                  <div className="col-6">
                    <span className="fw-bold">Date:</span>
                    <span className="ms-2">
                      {appointmentDetails.meetingdate ||
                        appointmentDetails.date}
                    </span>
                  </div>
                  <div className="col-6">
                    <span className="fw-bold">Time:</span>
                    <span className="ms-2">
                      {appointmentDetails.starttime} -{" "}
                      {appointmentDetails.endtime}
                    </span>
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-6">
                    <span className="fw-bold">Duration:</span>
                    <span className="ms-2">{appointmentDetails.duration}</span>
                  </div>
                  <div className="col-6">
                    <span className="fw-bold">Location:</span>
                    <span className="ms-2">{appointmentDetails.location}</span>
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-6">
                    <span className="fw-bold">Status:</span>
                    <span
                      className={`ms-2 badge ${
                        appointmentDetails.isaccepted
                          ? "bg-success"
                          : "bg-warning"
                      }`}
                    >
                      {appointmentDetails.isaccepted ? "Accepted" : "Pending"}
                    </span>
                  </div>
                  <div className="col-6">
                    <span className="fw-bold">Details:</span>
                    <span className="ms-2">
                      {appointmentDetails.meetingdetails}
                    </span>
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-6">
                    <span className="fw-bold">Reason:</span>
                    <span className="ms-2">
                      {appointmentDetails.meetingreason}
                    </span>
                  </div>
                  <div className="col-6">
                    <span className="fw-bold">Comments:</span>
                    <span className="ms-2">{appointmentDetails.message}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="text-center text-muted py-5">
            <div>No appointment details available.</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AppointmentDetailsPopup;
